"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClosestPriceRange = void 0;
exports.getClosestPriceRange = function (price, presets) {
    var matchedPresetIndex = presets
        .map(function (it) { return it.to === -1 ? __assign(__assign({}, it), { to: Number.POSITIVE_INFINITY }) : it; })
        .findIndex(function (it) { return price >= it.from && price <= it.to; });
    return matchedPresetIndex >= 0 ? presets[matchedPresetIndex] : presets[0];
};
